module.exports = "/images/vendor/flag-icon-css/flags/1x1/kh.svg?61a4b374334e719cd3d6fffa0390eb15";